export class HtmlComponent {

  constructor(public name: string, public blockName: string, public type: string, public path: string, public htmlAdmin: string, public html: string, public htmlPdf: string,
    public tableHtml: string, public tableHtmlReadOnly: string, public jsData: string, public cssData: string, public isNew: boolean, public index: number, public checked: boolean,  public hasErrorInComponent: boolean) {}

}
